import en_message from "./en-US"

const locales = { "en-US": en_message }

export default locales
